import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="gradient-bg py-20 text-white md:py-24">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="mb-4 text-3xl font-bold tracking-tight md:text-4xl">Run your jobs with one organized contractor platform.</h2>
        <p className="mb-10 text-lg leading-relaxed text-blue-100 md:text-xl">
          Build professional quotes on Free, then upgrade to Pro for projects, team portal access, job costs, and email delivery from Devello.
        </p>
        <div className="mb-10 flex flex-col justify-center gap-4 sm:flex-row">
          <Link to="/account" className="block sm:inline-block">
            <button
              type="button"
              className="w-full rounded-2xl bg-white px-8 py-4 text-lg font-bold text-primary shadow-strong transition-colors hover:bg-gray-100 sm:w-auto"
            >
              Start Building Invoices
            </button>
          </Link>
          <Link to="/plans" className="block sm:inline-block">
            <button
              type="button"
              className="glass-effect w-full rounded-2xl border-2 border-white px-8 py-4 text-lg font-bold text-white transition-colors hover:bg-white/20 sm:w-auto"
            >
              See pricing
            </button>
          </Link>
        </div>
        <div className="flex flex-col items-center justify-center gap-3 text-sm text-blue-100 sm:flex-row sm:space-x-10">
          <div className="flex items-center">
            <svg className="mr-2 h-5 w-5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            Contractors across Canada and the United States
          </div>
          <div className="flex items-center">
            <svg className="mr-2 h-5 w-5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            Quotes, projects, team portal, and expenses in one dashboard
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
